// @flow
import type { FieldConfig } from '../FieldConfig';

export const pageId: FieldConfig = {
  name: 'page_id',
  label: 'Page ID',
  type: 'text',
};

export const variantId: FieldConfig = {
  name: 'variant_id',
  label: 'Variant ID',
  type: 'text',
};

export const locale: FieldConfig = {
  name: 'locale',
  label: 'Locale',
  type: 'text',
};

export const productName: FieldConfig = {
  name: 'product_name',
  label: 'Product Name',
  type: 'text',
};

export const brand: FieldConfig = {
  name: 'brand',
  label: 'Brand',
  type: 'text',
};
export const category: FieldConfig = {
  name: 'category',
  label: 'Category',
  type: 'text',
};

export const rating: FieldConfig = {
  name: 'between_star_rating',
  label: 'Star Rating',
  type: 'RatingRange',
  defaultValue: [1, 5],
};

export const reviewIncludesResponse: FieldConfig = {
  name: 'includes_response',
  label: 'Includes Response',
  type: 'select',
  options: [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ],
  placeholder: 'Any',
};

export const isUpdatedReview: FieldConfig = {
  name: 'is_new_ugc',
  label: 'Updated Review',
  type: 'select',
  options: [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ],
  placeholder: 'Any',
};

export const questionIncludesAnswer: FieldConfig = {
  name: 'includes_answer',
  label: 'Has Answer',
  type: 'select',
  options: [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ],
  placeholder: 'Any',
};

export const questionHasVisualAnswers: FieldConfig = {
  name: 'includes_answer_media',
  label: 'Has Visual Answer',
  type: 'select',
  options: [
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ],
  placeholder: 'Any',
};

export const reviewerType: FieldConfig = {
  name: 'reviewer_type',
  label: 'Reviewer Type',
  type: 'multiselect',
  options: [
    { label: 'Staff Expert', value: 'staff_expert' },
    { label: 'Staff Reviewer', value: 'staff_reviewer' },
    { label: 'Verified Buyer', value: 'verified_buyer' },
    { label: 'Verified Reviewer', value: 'verified_reviewer' },
  ],
  placeholder: 'Any Type',
};

export const author: FieldConfig = {
  name: 'author',
  label: 'Author',
  type: 'text',
};

export const reviewHeadline: FieldConfig = {
  name: 'headline',
  label: 'Headline',
  type: 'text',
};

export const questionType: FieldConfig = {
  name: 'question_type',
  label: 'Question Type',
  type: 'multiselect',
  placeholder: 'Any Type',
  options: [],
};

export const answerType: FieldConfig = {
  name: 'answer_type',
  label: 'Answer Type',
  type: 'multiselect',
  placeholder: 'Any Type',
  options: [],
};

export const answerStatus: FieldConfig = {
  name: 'answer_status',
  label: 'Answer Status',
  type: 'multiselect',
  placeholder: 'Any Status',
  options: [],
};

export const ugcId: FieldConfig = {
  name: 'ugc_id',
  label: 'UGC ID',
  type: 'text',
};

export const codesIncluded: FieldConfig = {
  name: 'included_observations',
  label: 'Observations Included',
  type: 'multiselect',
  options: [],
  placeholder: 'Any Code',
};

export const codesExcluded: FieldConfig = {
  name: 'excluded_observations',
  label: 'Observations Excluded',
  type: 'multiselect',
  options: [],
};

export const statusIncluded: FieldConfig = {
  name: 'included_status',
  label: 'Status Included',
  type: 'multiselect',
  options: [],
  placeholder: 'Any Status',
};

export const statusExcluded: FieldConfig = {
  name: 'excluded_status',
  label: 'Status Excluded',
  type: 'multiselect',
  options: [],
};

export const siteStatus: FieldConfig = {
  name: 'published',
  label: 'Site Status',
  type: 'select',
  options: [
    { label: 'Published', value: 'true' },
    { label: 'Unpublished', value: 'false' },
  ],
  placeholder: 'Any Status',
};

export const native: FieldConfig = {
  name: 'native',
  label: 'Native/Syndicated',
  type: 'select',
  options: [
    { label: 'Only Native UGC', value: 'true' },
    { label: 'Only Syndicated UGC', value: 'false' },
  ],
  placeholder: 'All UGC',
};

export const catalog: FieldConfig = {
  name: 'catalog_id',
  label: 'Catalog',
  type: 'select',
  options: [],
  placeholder: 'Any Catalog',
};

export const merchantUserEmail: FieldConfig = {
  name: 'merchant_email',
  label: 'Merchant User Email',
  type: 'text',
};

export const merchantUserId: FieldConfig = {
  name: 'merchant_user_id',
  label: 'Merchant User ID',
  type: 'text',
};

export const commentsKeyword: FieldConfig = {
  name: 'comments_keywords',
  label: 'Comments Keyword',
  type: 'text',
};

export const questionKeyword: FieldConfig = {
  name: 'question_keyword',
  label: 'Question Keyword',
  type: 'text',
};

export const answerKeyword: FieldConfig = {
  name: 'answer_keyword',
  label: 'Answer Keyword',
  type: 'text',
};
export const contentDisclosureCodes: FieldConfig = {
  name: 'disclosure_codes',
  label: 'Content Disclosure Codes',
  type: 'multiselect',
  options: [
    { label: 'Sampling', value: 'sampling' },
    { label: 'Sweepstakes', value: 'sweepstakes' },
  ],
  placeholder: 'Any Disclosure Code',
};

export const deviceId: FieldConfig = {
  name: 'device_id',
  label: 'Device ID',
  type: 'text',
};

export const sortBy: FieldConfig = {
  name: 'sort_order',
  label: 'Sort Options',
  type: 'select',
  options: [
    { label: 'Newest to oldest', value: 'desc' },
    { label: 'Oldest to newest', value: 'asc' },
  ],
  defaultValue: 'desc',
};

export const startDate: FieldConfig = {
  name: 'start_date',
  type: 'date',
};

export const endDate: FieldConfig = {
  name: 'end_date',
  type: 'date',
};

export const clientId: FieldConfig = {
  name: 'client_id',
  label: 'client_id',
  type: 'text',
};

export const ugcTypeFieldName = 'ugc_type';

export const setReadonlyUgcType = (
  ...ugctypes: Array<UgcType>
): FieldConfig => ({
  name: ugcTypeFieldName,
  label: 'UGC Type',
  type: 'hidden',
  defaultValue: ugctypes.join(' '),
});

export const createUgcId = (label: string) => ({
  ...ugcId,
  label: `${label} ID`,
});

export const mediaUgcType: FieldConfig = {
  name: ugcTypeFieldName,
  label: 'UGC Type',
  type: 'select',
  options: [
    { label: 'Image', value: 'Image' },
    { label: 'Video', value: 'Video' },
  ],
  placeholder: 'Any',
};

export const pwrDistroMediaUgcType: FieldConfig = {
  name: ugcTypeFieldName,
  label: 'UGC Type',
  type: 'select',
  options: [
    { label: 'Image', value: 'Image' },
    { label: 'Video', value: 'Video' },
  ],
  placeholder: 'Any',
  defaultValue: 'Image,Video',
};
// need to do something about media ugc type to work with new endpoint



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/config/fields.config.js